<div
  *ngIf="status"
  [ngClass]="{
    success: status.toLowerCase() === 'success',
    error: status.toLowerCase() === 'error'
  }"
>
  {{ status.toLowerCase() }}
</div>